import React from 'react';
import {
  TextField,
  IconButton,
  Autocomplete,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ServerTable from './components/ServerTable';
import useServerExplorer from './hooks/useServerExplorer';
import '../../Styles/Components/ServerExplorer.css';

const ServerExplorer = ({ onClose, onSelectServer }) => {
  const {
    servers,
    marketList,
    searchTerm,
    selectedMarket,
    loading,
    error,
    setSearchTerm,
    setSelectedMarket,
    processServerSelection
  } = useServerExplorer();

  const handleServerSelect = (server) => {
    const processedData = processServerSelection(server);
    if (processedData) {
      onSelectServer(processedData);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <div className="server-explorer-container">
      <Box className="server-explorer-header">
        <div className="server-explorer-header-content">
          <Typography variant="h5" component="h2">
            Server Explorer
          </Typography>
          <IconButton onClick={onClose} className="server-explorer-close-button">
            <CloseIcon />
          </IconButton>
        </div>
      </Box>

      <div className="server-explorer-search-section">
        <div className="server-explorer-details-group">
          <TextField
            fullWidth
            label="Search by Server ID or Name"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="server-explorer-search-field"
            InputProps={{
              endAdornment: searchTerm && (
                <IconButton
                  onClick={() => setSearchTerm('')}
                  size="small"
                  edge="end"
                >
                  <CloseIcon />
                </IconButton>
              ),
            }}
          />

          <Autocomplete
            options={marketList}
            getOptionLabel={(option) => option.label}
            value={selectedMarket}
            onChange={(e, newValue) => setSelectedMarket(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Filter by Market"
                variant="outlined"
              />
            )}
            className="server-explorer-market-filter"
          />
        </div>
      </div>

      <div className="server-explorer-table-section">
        <ServerTable
          servers={servers}
          onSelectServer={handleServerSelect}
        />
      </div>
    </div>
  );
};

export default ServerExplorer;